export default "__VITE_ASSET__ChiPHbFZ__"